import { flowRight, map } from 'lodash-es';
import { extractMetadata } from './content';

// Curried iterattee-first pure fp functions for compose
export const getChild = childId => content => content.child(childId);

export const getChildren = content => content.children();

export const getAllMetadata = content => content.getAllMetadata();

export const getMetadataValue = metadataName => content => content.metadata(metadataName).value();

export const getMetadataByKeys = metadataKeys => content => extractMetadata(metadataKeys, content);

export const getChildrenAllMetadata = flowRight(content => map(content, getAllMetadata), getChildren);

export const getChildrenOfChild = childId => flowRight(getChildren, getChild(childId));
